export const generateEducationYear = (educationYear, translate) => {
  const yearKey = `${educationYear?.year}`;
  const levelKey = educationYear?.educationLevel?.guid;

  return `${translate(`${levelKey}.${yearKey}`)}`;
};
